module.exports = __webpack_public_path__ + "static/media/DSC_2215-2.f0487ecf.jpg";